"use client"
import React from "react"
import moment from "moment"
import {
  BarChart,
  Bar,
  LineChart,
  Line,
  PieChart as RechartsPieChart,
  Pie,
  Cell,
  Sector,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts"
// import routes from "../../routes/URL" // Original import
import { Grid, Box, Tooltip as MUITooltip } from "@material-ui/core"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { formatNumberWithCommas } from "../../common/util" // Original import
import Text from "../../components/Text" // Original import
import API, { URL_PATH } from "../../services/API" // Original import
import redux from "../../common/Redux" // Original import
// import assets from "../../common/assets" // Original import
import urls from "../../routes/URL" // Original import
import Toast from "../../components/Toast" // Original import
import VerificationModal from "../../components/VerificationModal" // Original import
import { Fullscreen, TrendingUp, Utensils, Package, Calendar, Star, Users, Repeat, DollarSign, RefreshCw } from "lucide-react"
import routes from "../../routes/URL" // Importing routes for navigation
// --- MOCK IMPORTS FOR DEMONSTRATION ---


// Mock assets for icons
const assets = {
  trendIcon: <TrendingUp className="w-6 h-6" />,
  dineinIcon: <Utensils className="w-6 h-6" />,
  pickupIcon: <Package className="w-6 h-6" />,
  calendarIcon: <Calendar className="w-6 h-6" />,
reloadIcon: <RefreshCw className="w-6 h-6 text-white" />,
  categoryIcon: <Utensils className="w-6 h-6" />, // New icon for category sales
  customerRatingIcon: <Star className="w-6 h-6" />, // New icon for customer ratings
  newCustomerIcon: <Users className="w-6 h-6" />, // New icon for new customers
  repeatCustomerIcon: <Repeat className="w-6 h-6" />, // New icon for repeat customers
  gstIcon: <DollarSign className="w-6 h-6" />, // New icon for GST
}
const urlss = {
  admin: {
    reports: {
      categorysales: "/reports/category-sales",
      customerrating: "/reports/customer-ratings",
      newcustomer: "/reports/new-customers",
      repeatcustomer: "/reports/repeat-customers",
    },
  },
}

const theme = {
  background: "#02111B",
  btnColor: "#FFC857",
  blackColor: "#07070A",
  dropdownColor: "#16232C",
  greytxtcolor: "#9CA3AF",
  greybordercolor: "#374151",
  primary: "#ffc857",
  secondary: "#bb0a21",
  white: "#ffffff",
  drawerBgColor: "#16232c",
  pageBgColor: "#041A29",
  redColor: "#ed1c24",
  greenColor: "#00a651",
  blueColor: "#00a8ff",
  mutedWhite: "#9CA3AF",
  rootBgColor: "#02111b",
}
// --- END MOCK IMPORTS ---



class Dashboard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      version: 1,
      loading: true,
      data: [],
      openFor: "",
      datemodalopen: false,
      mounted: false,
      currency: "",
      kot: null,
      all_time: null,
      today: null,
      yesterday: null,
      viewFor: "all_time",
      startDate: moment().subtract(60, "days")._d,
      endDate: moment()._d,
      most_order_dish: [],
      activeIndex: 0,
      showVerificationModal: false,
      verificationMessage: "",
      toast: {
        open: false,
        message: "",
        severity: "success",
      },
      showSubscriptionExpiredModal: false,
      overAll: null,
      dinein: null,
      pickup: null,
      booking: null,
      tips: null,
      users: null,
      gst: null,
      fullscreenChart: null,
      // New state for the new cards' data
      categorySalesData: null,
      customerRatingsData: null,
      newCustomersData: null,
      repeatCustomersData: null,
    }
  }
  componentDidMount() {
    this.getDataForTab()
    console.log("this.props.selectedHotelId.",this.props)
    // Mock selectedHotelId for demonstration
    const currency = this.getCurrency(this.props.selectedHotelId.currency) 
    this.setState({ currency }) // Store selectedHotelId in state for use in navigation
    this.mostOrderDish()
    this.fetchNewCardData() // Fetch data for new cards
  }
  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity,
      },
    })
  }
  toggleFullscreen = (chartData) => {
    this.setState({
      fullscreenChart: this.state.fullscreenChart ? null : chartData,
    })
  }
  handleCloseVerificationModal = () => {
    this.setState({ showVerificationModal: false })
  }
  handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false,
      },
    })
  }
  getCurrency = (currencyCode) => {
    const currencyMap = {
      USD: "$",
      EUR: "€",
      GBP: "£",
      INR: "₹",
    }
    return currencyMap[currencyCode] || currencyCode
  }
  mostOrderDish = async () => {
    console.log("callingggggggggggggggggg")
    try {
      const { status, message, data } = await API(this, "get", URL_PATH.mostOrderDish)
      console.log("++++++++++++++++++", data)
      if (status === "error") {
        return this.props.okDialog && this.props.okDialog(message) // Check if okDialog exists
      }
      this.setState({ most_order_dish: data, mounted: true })
    } catch (error) {
      console.error("Error fetching most ordered dishes:", error)
    }
  }
  getDataForTab = async () => {
    this.fetchData()
    this.getTabData()
  }

  // New method to fetch data for the new cards
  fetchNewCardData = async () => {
    const { selectedHotelId } = this.state
    const hotelId = this.props.selectedHotelId?.id

    try {
      // Fetch Category Sales data
      const categorySalesRes = await API(
        this,
        "get",
        `${URL_PATH.listingReports}?hotel_id=${hotelId}&type=category_sales`,
      )
      if (categorySalesRes.status === "success") {
        this.setState({ categorySalesData: categorySalesRes.data })
      }

      // Fetch Customer Ratings data
      const customerRatingsRes = await API(
        this,
        "get",
        `${URL_PATH.listingReports}?hotel_id=${hotelId}&type=customer_ratings`,
      )
      if (customerRatingsRes.status === "success") {
        this.setState({ customerRatingsData: customerRatingsRes.data })
      }

      // Fetch New Customers data
      const newCustomersRes = await API(
        this,
        "get",
        `${URL_PATH.listingReports}?hotel_id=${hotelId}&type=new_customers`,
      )
      if (newCustomersRes.status === "success") {
        this.setState({ newCustomersData: newCustomersRes.data })
      }

      // Fetch Repeat Customers data
      const repeatCustomersRes = await API(
        this,
        "get",
        `${URL_PATH.listingReports}?hotel_id=${hotelId}&type=repeat_customers`,
      )
      if (repeatCustomersRes.status === "success") {
        this.setState({ repeatCustomersData: repeatCustomersRes.data })
      }
    } catch (error) {
      console.error("Error fetching new card data:", error)
    }
  }

  convertDateForServer = (date) => {
    return moment(date).format("YYYY-MM-DD")
  }
  renderSubscriptionExpiredModal = () => {
    const { showSubscriptionExpiredModal } = this.state
    if (!showSubscriptionExpiredModal) return null
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          zIndex: 9999,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            backgroundColor: "#041A29",
            color: "#E2E8F0",
            borderRadius: "12px",
            padding: "24px",
            width: "90%",
            maxWidth: "500px",
            border: "1px solid #1E293B",
            boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.25)",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "16px",
            }}
          >
            <button
              onClick={() => this.setState({ showSubscriptionExpiredModal: false })}
              style={{
                background: "none",
                border: "none",
                color: "#94A3B8",
                cursor: "pointer",
                fontSize: "20px",
              }}
            >
              ×
            </button>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              padding: "16px",
            }}
          >
            <div
              style={{
                backgroundColor: "rgba(239, 68, 68, 0.1)",
                color: "#EF4444",
                width: "64px",
                height: "64px",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "16px",
              }}
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                <line x1="12" y1="9" x2="12" y2="13"></line>
                <line x1="12" y1="17" x2="12.01" y2="17"></line>
              </svg>
            </div>
            <h3
              style={{
                fontWeight: 600,
                color: "#F8FAFC",
                fontSize: "1.5rem",
                marginBottom: "8px",
              }}
            >
              Plan Expired
            </h3>
            <p
              style={{
                color: "#94A3B8",
                fontSize: "14px",
                marginBottom: "24px",
              }}
            >
              Your subscription is not active. Please renew your plan to continue using our services.
            </p>
            <button
              onClick={() => {
                this.setState({ showSubscriptionExpiredModal: false })
                this.props.history && this.props.history.push(urlss.admin.subscription.root) // Check if history exists
              }}
              style={{
                background: "#3B82F6",
                color: "white",
                border: "none",
                borderRadius: "8px",
                padding: "12px 24px",
                fontWeight: 500,
                fontSize: "0.95rem",
                cursor: "pointer",
                width: "100%",
                transition: "all 0.2s ease",
                "&:hover": {
                  background: "#2563EB",
                },
              }}
            >
              Go to Plans
            </button>
          </div>
        </div>
      </div>
    )
  }
  fetchData = async () => {
    console.log("this.props", this.props)
    try {
      const { startDateFormatted, endDateFormatted } = this.getDates()
      const url = `${URL_PATH.getDashboardGraphsV2}?start_date=${startDateFormatted}&end_date=${endDateFormatted}`
      const response = await API(this, "get", url)
      const status = response?.status
      const message = response?.message ?? ""
      const data = response?.data
      const statusLower = typeof status === "string" ? status.toLowerCase() : status
      const isStatusFailure = statusLower !== "success" && statusLower !== true && statusLower !== "true"
      // Check for subscription inactive message
      if (message.toLowerCase().includes("your subscription is not active")) {
        this.setState({
          loading: false,
          showSubscriptionExpiredModal: true, // New state for subscription expired modal
        })
        return
      }
      if (isStatusFailure) {
        this.setState({
          loading: false,
          showVerificationModal: true,
        })
        return
      }
      if ((statusLower === "true" || statusLower === true) && !Array.isArray(data)) {
        console.log(message)
        this.setState({ loading: false })
        return
      }
      const datamix = []
      let temp = []
      data.forEach((item, index) => {
        temp.push(item)
        if (index % 2 === 1 || index === data.length - 1) {
          datamix.push(temp)
          temp = []
        }
      })
      this.setState({ data: datamix, loading: false })
    } catch (error) {
      console.error("Error fetching dashboard data:", error)
      this.setState({ loading: false })
      window.Alert && window.Alert("An unexpected error occurred. Please try again.") // Check if window.Alert exists
    }
  }
  getTabData = async () => {
    try {
      const { startDateFormatted, endDateFormatted } = this.getDates()
      const url = `${URL_PATH.getDashboardDataV2}?start_date=${startDateFormatted}&end_date=${endDateFormatted}`
      const { status, message, data } = await API(this, "get", url)
      if (status === "error") {
        return this.props.okDialog && this.props.okDialog(message) // Check if okDialog exists
      }
      const { overAll, dinein, pickup, booking, tips, users, gst, net_earning } = data
      this.setState({
        overAll,
        dinein,
        pickup,
        booking,
        tips,
        users,
        gst,
        net_earning,
        mounted: true,
      })
    } catch (error) {
      console.error("Error fetching tab data:", error)
    }
  }
  // Mock URLs object - replace with your actual URLs

  navigateToReport = (path) => {
    // Replace with your navigation logic
    if (this.props.history) {
      this.props.history.push(path)
    } else {
      // For demo purposes, just log the navigation
      console.log("Navigate to:", path)
      // You can also use window.location.href = path or your routing solution
    }
  }
  getDates = () => {
    let { startDate, endDate, viewFor } = this.state
    if (viewFor !== "custom") {
      switch (viewFor) {
        case "today":
          startDate = moment()._d
          endDate = moment().add(1, "days")._d
          break
        case "this_week":
          startDate = moment().startOf("week")._d
          endDate = moment().endOf("week")._d
          break
        case "this_month":
          startDate = moment().startOf("month")._d
          endDate = moment().endOf("month")._d
          break
        case "past_6_month":
          startDate = moment().subtract(6, "months")._d
          endDate = moment()._d
          break
        case "all_time":
          startDate = moment().subtract(10, "years")._d
          endDate = moment()._d
          break
        default:
          break
      }
    }
    const startDateFormatted = this.convertDateForServer(startDate)
    const endDateFormatted = this.convertDateForServer(endDate)
    return { startDate, endDate, startDateFormatted, endDateFormatted }
  }
  ExampleCustomInput = React.forwardRef(({ value, onClick }, ref) => {
    const formatedDate = moment(value).format("DD-MM-YYYY")
    return (
      <button
        className="btn btn-primary mx-1"
        onClick={onClick}
        ref={ref}
        style={{
          minWidth: "150px",
          backgroundColor: "#00111B",
          color: "white",
          border: "1px solid #16232c",
          borderRadius: "4px",
          padding: "10px",
          cursor: "pointer",
        }}
      >
        {formatedDate}
      </button>
    )
  })
  Tab = ({
    title,
    type = "label",
    leftIcon,
    leftIconBgColor,
    textColor,
    customerString,
    data,
    clickAction = null,
    isTipCard = false,
    isUserCard = false,
    isGstCard = false,
  }) => {
    if (!data) return null
    let formattedDate = ""
    if (!isTipCard && !isUserCard && !isGstCard) {
      formattedDate = data.last_order_time ? moment(data.last_order_time).format("DD-MMM-YYYY, hh:mm A") : ""
    }
    return (
      <Box
        sx={{
          padding: "16px",
          backgroundColor: "#041A29",
          borderRadius: "15px",
          margin: "5px",
          cursor: clickAction ? "pointer" : "default",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          transition: "transform 0.2s, box-shadow 0.2s",
          "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: "0 6px 16px rgba(0, 0, 0, 0.2)",
          },
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
        onClick={clickAction}
      >
        <Box sx={{ position: "relative" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Box
              style={{
                padding: "8px",
                borderRadius: "8px",
                backgroundColor: leftIconBgColor,
                marginRight: "8px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {/* Render Lucide React icon if it's a React element, otherwise use img for string paths */}
              {React.isValidElement(leftIcon) ? (
                leftIcon
              ) : (
                <img src={leftIcon || "/placeholder.svg"} width="24px" height="24px" alt={title} className="icon" />
              )}
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                marginTop: "3px",
              }}
            >
              <div
                style={{
                  color: "white",
                  fontWeight: "500",
                  fontSize: "0.95rem",
                }}
              >
                {title}
              </div>
              {!isTipCard && !isUserCard && !isGstCard && (
                <div
                  style={{
                    color: "#626D7D",
                    fontSize: "0.75rem",
                  }}
                >
                  {formattedDate}
                </div>
              )}
            </Box>
          </Box>
        </Box>
        {/* <MUITooltip
          title={
            isTipCard
              ? data.select_tip_amount
              : isUserCard
                ? data.visited_users_count
                : isGstCard
                  ? data
                  : data.select_order_amount
          }
          placement="top"
        > */}
        <div
          style={{
            fontSize: "1.5rem",
            fontWeight: "600",
            marginTop: "12px",
            color: "white",
          }}
        >
          {isTipCard || isUserCard || isGstCard ? "" : this.state.currency}
          {formatNumberWithCommas(
            isTipCard
              ? data.select_tip_amount
              : isUserCard
                ? data.visited_users_count
                : isGstCard
                  ? data
                  : data.select_order_amount,
          )}
        </div>
        {!isGstCard && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-end",
              marginTop: "8px",
              flexGrow: 1,
            }}
          >
            {!isTipCard && !isUserCard && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  flex: 6,
                }}
              >
                <span
                  style={{
                    color: textColor,
                    backgroundColor: leftIconBgColor,
                    padding: "4px 12px",
                    borderRadius: "30px",
                    marginRight: "8px",
                    fontWeight: "500",
                    fontSize: "0.85rem",
                  }}
                >
                  {data.select_order_count ?? "0"}
                </span>
                <Text
                  style={{
                    color: textColor,
                    fontSize: "0.8rem",
                  }}
                >
                  {customerString}
                </Text>
              </Box>
            )}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
              }}
            >
              <span
                style={{
                  color: "#26AB5F",
                  fontWeight: "500",
                  fontSize: "0.8rem",
                }}
              >
                Today
              </span>
              <MUITooltip
                title={
                  isTipCard ? data.today_tip_amount : isUserCard ? data.today_visited_users_count : data.today_amount
                }
                placement="top"
              >
                <span
                  style={{
                    color: "#26AB5F",
                    fontWeight: "500",
                    fontSize: "0.8rem",
                  }}
                >
                  +{isUserCard ? "" : this.state.currency}
                  {formatNumberWithCommas(
                    isTipCard ? data.today_tip_amount : isUserCard ? data.today_visited_users_count : data.today_amount,
                  )}
                </span>
              </MUITooltip>
            </Box>
          </Box>
        )}
      </Box>
    )
  }
  // Compact horizontal card component (similar to image)
  CompactCard = ({ title, data, isTipCard = false, isUserCard = false, isGstCard = false }) => {
    if (!data) return null
    return (
      <Box
        sx={{
          backgroundColor: "#041A29",
          padding: "12px 16px",
          height: "60px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderRadius: "8px",
          transition: "transform 0.2s",
          "&:hover": {
            transform: "translateY(-1px)",
          },
          minWidth: 0, // Allow flex shrinking
        }}
      >
        {/* Left side - Title */}
        <Text
          style={{
            color: "white",
            fontWeight: "500",
            fontSize: "0.9rem",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            marginRight: "12px",
          }}
        >
          {title}
        </Text>
        {/* Right side - Value */}
        <Text
          style={{
            color: "white",
            fontWeight: "600",
            fontSize: "1.1rem",
            whiteSpace: "nowrap",
          }}
        >
          {isUserCard ? "" : this.state.currency}
          {formatNumberWithCommas(isTipCard ? data.select_tip_amount : isUserCard ? data.visited_users_count : data)}
        </Text>
      </Box>
    )
  }
  Section = ({ label, item, children }) => {
    const { type } = item
    if (type === "pie") return null
    // Get all dates from the data
    const dates = item.data?.labels || []
    // Calculate date range to display for line graphs
    let dateRangeText = ""
    if (dates.length > 0 && type === "line") {
      const startDate = moment(dates[0], "DD MMM YYYY")
      const endDate = moment(dates[dates.length - 1], "DD MMM YYYY")
      if (startDate.isSame(endDate, "month") && startDate.isSame(endDate, "year")) {
        // Single month case
        dateRangeText = startDate.format("MMM YYYY")
      } else if (startDate.isSame(endDate, "year")) {
        // Same year, different months
        dateRangeText = `${startDate.format("MMM")} - ${endDate.format("MMM YYYY")}`
      } else {
        // Different years
        dateRangeText = `${startDate.format("MMM YYYY")} - ${endDate.format("MMM YYYY")}`
      }
    }
    // Check if this is a GST-related graph
    const isGstGraph =
      label &&
      (label.toLowerCase().includes("gst") ||
        label.toLowerCase().includes("tax") ||
        item.title?.toLowerCase().includes("gst") ||
        item.title?.toLowerCase().includes("tax"))
    return (
      <div
        style={{
          backgroundColor: "#041A29",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          borderRadius: "10px",
          padding: "20px",
          flex: 1,
          margin: "10px",
          transition: "transform 0.2s",
          overflowY: "hidden",
        }}
      >
        <div style={{ marginBottom: "20px", borderBottom: "1px solid rgba(255, 255, 255, 0.1)", paddingBottom: "8px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <h4
              style={{
                fontWeight: "bold",
                fontSize: "20px",
                color: "white",
                margin: 0,
              }}
            >
              {label}
            </h4>
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              {type === "line" && dateRangeText && (
                <span
                  style={{
                    color: "white",
                    fontSize: "14px",
                    fontWeight: "normal",
                  }}
                >
                  {dateRangeText}
                </span>
              )}
              {/* Fullscreen Icon */}
              <button
                onClick={() => this.toggleFullscreen({ label, item, children, isGstGraph })}
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "4px",
                  borderRadius: "4px",
                  transition: "background-color 0.2s",
                  color: "white",
                  marginBottom: "4px",
                }}
                onMouseEnter={(e) => (e.target.style.backgroundColor = "rgba(255,255,255,0.1)")}
                onMouseLeave={(e) => (e.target.style.backgroundColor = "transparent")}
              >
                {/* Fullscreen SVG Icon */}
                <Fullscreen className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
        <div style={{ height: "400px" }}>
          {isGstGraph && this.state.gst && (
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: "16px",
                fontSize: "14px",
                paddingBottom: "16px",
                borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
              }}
            >
              <div>
                <strong>SGST:</strong> {this.state.currency}
                {formatNumberWithCommas(this.state.gst.SGST_amount)}
              </div>
              <div>
                <strong>CGST:</strong> {this.state.currency}
                {formatNumberWithCommas(this.state.gst.CGST_amount)}
              </div>
              <div>
                <strong>Total GST:</strong> {this.state.currency}
                {formatNumberWithCommas(this.state.gst.GST_amount)}
              </div>
              <div>
                <strong>Net Earning:</strong> {this.state.currency}
                {formatNumberWithCommas(this.state.net_earning.actual_earning_amount)}
              </div>
            </div>
          )}
          {children}
          {/* GST Information */}
        </div>
      </div>
    )
  }
  FullscreenModal = () => {
    const { fullscreenChart } = this.state
    if (!fullscreenChart) return null
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.95)",
          zIndex: 9999,
          display: "flex",
          flexDirection: "column",
          padding: "20px",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
            color: "white",
          }}
        >
          <h2 style={{ margin: 0, fontSize: "24px" }}>{fullscreenChart.label}</h2>
          <button
            onClick={() => this.toggleFullscreen(null)}
            style={{
              backgroundColor: "transparent",
              border: "none",
              color: "white",
              cursor: "pointer",
              fontSize: "24px",
              padding: "8px",
              borderRadius: "4px",
              transition: "background-color 0.2s",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "rgba(255,255,255,0.1)")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "transparent")}
          >
            ✕
          </button>
        </div>
        {/* GST Info for fullscreen */}
        {fullscreenChart.isGstGraph && this.state.gst && (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: "24px",
              fontSize: "16px",
              marginBottom: "20px",
              color: "white",
            }}
          >
            <div>
              <strong>SGST:</strong> {this.state.currency}
              {formatNumberWithCommas(this.state.gst.SGST_amount)}
            </div>
            <div>
              <strong>CGST:</strong> {this.state.currency}
              {formatNumberWithCommas(this.state.gst.CGST_amount)}
            </div>
            <div>
              <strong>Total GST:</strong> {this.state.currency}
              {formatNumberWithCommas(this.state.gst.GST_amount)}
            </div>
            <div>
              <strong>Net Earning:</strong> {this.state.currency}
              {formatNumberWithCommas(this.state.net_earning.actual_earning_amount)}
            </div>
          </div>
        )}
        {/* Chart */}
        <div
          style={{
            flex: 1,
            backgroundColor: "#041A29",
            borderRadius: "10px",
            padding: "20px",
          }}
        >
          <this.Bar obj={fullscreenChart.item} />
        </div>
      </div>
    )
  }
  Bar = ({ obj }) => {
    const { type, title, data, legend } = obj
    if (!data || !data.labels || !data.datasets) {
      return <div>No data available</div>
    }
    // Get axis labels from axis-data
    const axisData = obj["axis-data"] && obj["axis-data"][0] ? obj["axis-data"][0] : {}
    const xAxisLabel = axisData["x-axis"] || "X-Axis"
    const yAxisLabel = axisData["y-axis"] || "Y-Axis"
    const chartData = data.labels.map((label, index) => {
      const entry = { name: label }
      data.datasets.forEach((dataset, datasetIndex) => {
        entry[dataset.label || `Dataset ${datasetIndex + 1}`] = dataset.data[index]
      })
      return entry
    })
    // Get colors from legend or dataset
    const getColorForDataset = (datasetLabel) => {
      // First try to find in legend
      if (legend) {
        const legendItem = legend.find((item) => item.text.toLowerCase() === datasetLabel.toLowerCase())
        if (legendItem) return legendItem.color
      }
      // Then try to find in dataset
      const dataset = data.datasets.find((ds) => ds.label === datasetLabel)
      if (dataset) return dataset.borderColor || dataset.backgroundColor
      // Default fallback
      return "#FFC857" // Your default color
    }
    if (type === "doughnut" || type === "pie") {
      return null
    }
    if (type === "line") {
      return (
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 60 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" />
            <XAxis
              dataKey="name"
              tick={{ fill: "#fff", fontSize: 12 }}
              stroke="rgba(255,255,255,0.3)"
              label={{
                value: xAxisLabel,
                position: "insideBottom",
                offset: -1,
                style: { textAnchor: "middle", fill: "#fff", fontSize: "14px" },
              }}
              tickFormatter={(value) => {
                const date = moment(value, "DD MMM YYYY")
                return date.format("DD")
              }}
              axisLine={false}
              tickLine={false}
            />
            <YAxis
              tick={{ fill: "#fff", fontSize: 12 }}
              stroke="rgba(255,255,255,0.3)"
              label={{
                value: yAxisLabel,
                angle: -90,
                position: "insideLeft",
                style: { textAnchor: "middle", fill: "#fff", fontSize: "14px" },
              }}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: "#16232c",
                border: "1px solid rgba(255,255,255,0.2)",
                borderRadius: "4px",
                color: "#fff",
              }}
              itemStyle={{
                color: "#fff",
              }}
              formatter={(value, name, props) => {
                if (name === "GST") {
                  const sgst = value / 2
                  const cgst = value / 2
                  return [
                    <div key="gst-details">
                      <div key="gst">{`GST: ${formatNumberWithCommas(value)}`}</div>
                      <div key="sgst">{`SGST: ${formatNumberWithCommas(sgst)}`}</div>
                      <div key="cgst">{`CGST: ${formatNumberWithCommas(cgst)}`}</div>
                    </div>,
                  ]
                }
                return [`${formatNumberWithCommas(value)}`, name]
              }}
              labelFormatter={(label) => {
                const date = moment(label, "DD MMM YYYY")
                return `${date.format("DD MMM YYYY")}`
              }}
              labelStyle={{ color: "#fff", fontWeight: "bold" }}
            />
            <Legend wrapperStyle={{ color: "#fff", fontSize: "12px", bottom: "50px" }} />
            {[...data.datasets].reverse().map((dataset, index) => (
              <Line
                key={`line-${index}`}
                type="monotone"
                dataKey={dataset.label || `Dataset ${index + 1}`}
                stroke={getColorForDataset(dataset.label)}
                strokeWidth={2}
                dot={{ r: 4, strokeWidth: 2 }}
                activeDot={{ r: 6, strokeWidth: 2 }}
              />
            ))}
          </LineChart>
        </ResponsiveContainer>
      )
    }
    return (
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 60 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" />
          <XAxis
            dataKey="name"
            tick={{ fill: "#fff", fontSize: 12 }}
            stroke="rgba(255,255,255,0.3)"
            label={{
              value: xAxisLabel,
              position: "insideBottom",
              offset: -10,
              style: { textAnchor: "middle", fill: "#fff", fontSize: "14px" },
            }}
          />
          <YAxis
            tick={{ fill: "#fff", fontSize: 12 }}
            stroke="rgba(255,255,255,0.3)"
            label={{
              value: yAxisLabel,
              angle: -90,
              position: "insideLeft",
              style: { textAnchor: "middle", fill: "#fff", fontSize: "14px" },
            }}
          />
          <Legend wrapperStyle={{ color: "#fff", fontSize: "12px" }} />
          {data.datasets.map((dataset, datasetIndex) => (
            <Bar
              key={`bar-${datasetIndex}`}
              dataKey={dataset.label || `Dataset ${datasetIndex + 1}`}
              fill={getColorForDataset(dataset.label)}
              radius={[4, 4, 0, 0]}
              barSize={30}
              animationDuration={1500}
              activeBar={false}
              id={`bar-${datasetIndex}`}
            />
          ))}
          <Tooltip
            contentStyle={{
              backgroundColor: "#02111B",
              border: "1px solid rgba(255,255,255,0.2)",
              borderRadius: "4px",
              color: "#fff",
            }}
            itemStyle={{
              color: "#fff",
            }}
            formatter={(value, name) => [`${formatNumberWithCommas(value)}`, name]}
            labelFormatter={(label) => `${xAxisLabel}: ${label}`}
            labelStyle={{ color: "#fff", fontWeight: "bold" }}
          />
        </BarChart>
      </ResponsiveContainer>
    )
  }
  PieChart = ({ data }) => {
    if (!data || !data.labels || !data.datasets || !data.datasets[0].data) {
      return <div>No data available</div>
    }
    const chartData = data.labels.map((label, index) => ({
      name: label,
      value: data.datasets[0].data[index],
      id: `pie-segment-${index}`,
    }))
    const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#8884d8"]
    const renderActiveShape = (props) => {
      const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent, value } = props
      return (
        <g>
          <text x={cx} y={cy} dy={-20} textAnchor="middle" fill="#fff" fontSize={16}>
            {payload.name}
          </text>
          <text x={cx} y={cy} dy={10} textAnchor="middle" fill="#fff" fontSize={20} fontWeight="bold">
            {value}
          </text>
          <text x={cx} y={cy} dy={30} textAnchor="middle" fill="#999" fontSize={14}>
            {`(${(percent * 100).toFixed(2)}%)`}
          </text>
          <Sector
            cx={cx}
            cy={cy}
            innerRadius={innerRadius}
            outerRadius={outerRadius + 10}
            startAngle={startAngle}
            endAngle={endAngle}
            fill={fill}
          />
        </g>
      )
    }
    return (
      <ResponsiveContainer width="100%" height="100%">
        <RechartsPieChart>
          <Pie
            activeIndex={this.state.activeIndex}
            activeShape={renderActiveShape}
            data={chartData}
            cx="50%"
            cy="50%"
            innerRadius={70}
            outerRadius={100}
            fill="#8884d8"
            dataKey="value"
            onMouseEnter={(_, index) => this.setState({ activeIndex: index })}
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${entry.id}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip
            contentStyle={{
              backgroundColor: "#16232c",
              border: "1px solid rgba(255,255,255,0.2)",
              borderRadius: "4px",
              color: "#fff",
            }}
            itemStyle={{
              color: "#fff",
            }}
            formatter={(value, name) => [
              `${value} (${((value / chartData.reduce((acc, curr) => acc + curr.value, 0)) * 100).toFixed(1)}%)`,
              name,
            ]}
          />
        </RechartsPieChart>
      </ResponsiveContainer>
    )
  }
  render() {
    const {
      loading,
      data,
      overAll,
      dinein,
      pickup,
      booking,
      tips,
      users,
      gst,
      net_earning,
      mounted,
      startDate,
      endDate,
      viewFor,
      most_order_dish,
      selectedHotelId, // Access selectedHotelId from state
      categorySalesData,
      customerRatingsData,
      newCustomersData,
      repeatCustomersData,
    } = this.state
    console.log("abcd", this.state)
    const { showVerificationModal, verificationMessage } = this.state
    if (showVerificationModal) {
      return (
        <VerificationModal
          open={true}
          message={verificationMessage || "Your account is under verification."}
          onClose={this.handleCloseVerificationModal}
        />
      )
    }

    const hotelId = selectedHotelId?.id || "b868ecc1-37b6-438e-9263-05d8455c5f6c" // Fallback hotel_id

    return (
      <div
        className="container-fluid"
        style={{
          minHeight: "100vh",
          backgroundColor: "#00111B",
          color: "white",
          padding: "20px",
        }}
      >
        <style>
          {`
            .recharts-tooltip-wrapper {
              background-color: transparent !important;
            }
            .recharts-default-tooltip {
              background-color: #02111B !important;
              border: 1px solid rgba(255,255,255,0.2) !important;
              border-radius: 4px !important;
              color: white !important;
            }
            .recharts-tooltip-item {
              color: white !important;
            }
          `}
        </style>
        {mounted && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              marginBottom: "20px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#041A29",
                padding: "16px",
                borderRadius: "8px",
                marginBottom: "20px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  gap: "8px",
                }}
              >
                {["past_6_month", "this_month", "this_week", "today", "all_time", "custom"].map((period) => (
                  <button
                    key={period}
                    style={{
                      minWidth: "120px",
                      padding: "10px",
                      backgroundColor: viewFor === period ? "#203a53" : "#00111B",
                      color: "white",
                      border: `1px solid ${viewFor === period ? "#4c91ff" : "#16232c"}`,
                      borderRadius: "4px",
                      cursor: "pointer",
                      fontWeight: viewFor === period ? "bold" : "normal",
                      transition: "all 0.2s",
                    }}
                    onClick={() => this.setState({ viewFor: period }, this.getDataForTab)}
                  >
                    {period
                      .split("_")
                      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                      .join(" ")}
                  </button>
                ))}
              </div>
              {viewFor === "custom" && (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: { xs: "16px", md: "0" },
                    gap: "8px",
                  }}
                >
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => this.setState({ startDate: date })}
                    isClearable={false}
                    closeOnScroll={true}
                    placeholderText="From Date"
                    customInput={<this.ExampleCustomInput />}
                  />
                  <DatePicker
                    selected={endDate}
                    onChange={(date) => this.setState({ endDate: date })}
                    isClearable={false}
                    closeOnScroll={true}
                    placeholderText="To Date"
                    customInput={<this.ExampleCustomInput />}
                  />
                  <button
                    className="btn btn-primary"
                    onClick={this.getDataForTab}
                    style={{
                      backgroundColor: "#4c91ff",
                      border: "none",
                      borderRadius: "4px",
                      padding: "10px 20px",
                      cursor: "pointer",
                    }}
                  >
                    Apply
                  </button>
                </Box>
              )}
              <button
                onClick={this.getDataForTab}
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "8px",
                  borderRadius: "50%",
                  transition: "background-color 0.2s",
                }}
              >
                {/* Using the asset object directly for reloadIcon */}
                {React.isValidElement(assets.reloadIcon) ? (
                  assets.reloadIcon
                ) : (
                  <img src={assets.reloadIcon || "/placeholder.svg"} width="25px" alt="Reload" />
                )}
              </button>
            </Box>
            {/* Stats cards - First Row */}
     <Grid container spacing={2}>
  {/* Existing cards remain unchanged */}
  <Grid item xs={12} sm={6} md={3}>
    <this.Tab
      title="Overall Earnings"
      leftIcon={assets.trendIcon}
      leftIconBgColor="#203a53"
      textColor="#4c91ff"
      customerString="Total Orders"
      data={overAll}
      clickAction={() => this.props.history && this.props.history.push(urls.admin.orders.history(this.props.hotels[0].hotel_slug))}
    />
  </Grid>
  <Grid item xs={12} sm={6} md={3}>
    <this.Tab
      title="Dine-In Orders"
      leftIcon={assets.dineinIcon}
      leftIconBgColor="#691727"
      textColor="#f0a0a0"
      customerString="Dine-In Orders"
      data={dinein}
      clickAction={() => this.props.history && this.props.history.push(urls.admin.customBilling.dineIn(this.props.hotels[0].hotel_slug))}
    />
  </Grid>
  <Grid item xs={12} sm={6} md={3}>
    <this.Tab
      title="Pick-Up Orders"
      leftIcon={assets.pickupIcon}
      leftIconBgColor="#453e2a"
      textColor="#ffc063"
      customerString="Pick-Up Orders"
      data={pickup}
      clickAction={() => this.props.history && this.props.history.push(urls.admin.orders.root(this.props.hotels[0].hotel_slug))}
    />
  </Grid>
  <Grid item xs={12} sm={6} md={3}>
    <this.Tab
      title="Bookings"
      leftIcon={assets.calendarIcon}
      leftIconBgColor="#262856"
      textColor="#a294e0"
      customerString="Booking Orders"
      data={booking}
      clickAction={() => this.props.history && this.props.history.push(urls.admin.bookings.root(this.props.hotels[0].hotel_slug))}
    />
  </Grid>

  {/* NEW SIMPLIFIED CARDS WITH HEADING */}


</Grid>
          </Box>
        )}
        {/* Most ordered dishes */}
        {most_order_dish.length > 0 && (
          <div style={{ marginBottom: "30px", paddingLeft: "12px" }}>
            <h3 style={{ marginBottom: "16px" }}>Most Ordered Dishes</h3>
            <Grid container spacing={2}>
              {most_order_dish.map((item, index) => {
                const { menu_name, menu_type } = item
                return (
                  <Grid item xs={12} sm={6} md={4} lg={2} key={`dish-${index}`}>
                    <Box
                      sx={{
                        backgroundColor: "#041A29",
                        padding: "18px",
                        height: "100%",
                        borderLeft: `5px solid ${
                          menu_type === "veg"
                            ? "#4CAF50"
                            : menu_type === "nonveg"
                              ? "#F44336"
                              : menu_type === "jain"
                                ? "white"
                                : menu_type === "eggetarian"
                                  ? "#FFC857"
                                  : menu_type === "drinks"
                                    ? "#4C91FF"
                                    : "gray"
                        }`,
                        display: "flex",
                        alignItems: "center",
                        transition: "transform 0.2s",
                        "&:hover": {
                          transform: "translateY(-2px)",
                        },
                      }}
                    >
                      <Text style={{ color: "white" }}>{menu_name}</Text>
                    </Box>
                  </Grid>
                )
              })}
            </Grid>
          </div>
        )}
        {/* Payment Methods Section */}
        {/* Charts */}
        {!loading &&
          data.map((section, sectionIndex) => (
            <div
              key={`section-${sectionIndex}`}
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                justifyContent: "space-between",
                marginBottom: "20px",
              }}
            >
              <this.Section label={section[0].title} item={section[0]}>
                <this.Bar obj={section[0]} />
              </this.Section>
              {section[1] && (
                <this.Section label={section[1].title} item={section[1]}>
                  <this.Bar obj={section[1]} />
                </this.Section>
              )}
            </div>
          ))}
        <this.FullscreenModal />
                       <Grid container spacing={3}>
            <Grid item xs={12}>
              <h3
                style={{
                  marginBottom: "8px",
                  paddingLeft: "12px",
                  marginBottom: "8px",

                  color: theme.white,
                  fontSize: "24px",
                  fontWeight: "600",
                }}
              >
                Reports
              </h3>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Box
                sx={{
                  backgroundColor: theme.pageBgColor,
                  padding: "18px",
                  height: "100%",
                  borderLeft: `5px solid ${theme.btnColor}`,
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "4px",
                  transition: "transform 0.2s, box-shadow 0.2s",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    cursor: "pointer",
                    boxShadow: "0 4px 12px rgba(48, 48, 48, 0.3)",
                  },
                }}
                onClick={() => this.navigateToReport(urls.admin.reports.categorysales(this.props.hotels[0].hotel_slug))}
              >
                <div>
                  <h4
                    style={{
                      color: theme.white,
                      margin: 0,
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                  >
                    Category Sales
                  </h4>
                  <p
                    style={{
                      color: theme.mutedWhite,
                      margin: "4px 0 0 0",
                      fontSize: "12px",
                    }}
                  >
                    View sales by category
                  </p>
                </div>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Box
                sx={{
                  backgroundColor: theme.pageBgColor,
                  padding: "18px",
                  height: "100%",
                  borderLeft: `5px solid ${theme.btnColor}`,
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "4px",
                  transition: "transform 0.2s, box-shadow 0.2s",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    cursor: "pointer",
                    boxShadow: "0 4px 12px rgba(48, 48, 48, 0.3)",
                  },
                }}
                onClick={() => this.navigateToReport(urls.admin.reports.customerrating(this.props.hotels[0].hotel_slug))}
              >
                <div>
                  <h4
                    style={{
                      color: theme.white,
                      margin: 0,
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                  >
                    Customer Ratings
                  </h4>
                  <p
                    style={{
                      color: theme.mutedWhite,
                      margin: "4px 0 0 0",
                      fontSize: "12px",
                    }}
                  >
                    Customer feedback & ratings
                  </p>
                </div>
              </Box>
            </Grid>
  <Grid item xs={12} sm={6} md={3}>
              <Box
                sx={{
                  backgroundColor: theme.pageBgColor,
                  padding: "18px",
                  height: "100%",
                  borderLeft: `5px solid ${theme.btnColor}`,
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "4px",
                  transition: "transform 0.2s, box-shadow 0.2s",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    cursor: "pointer",
                    boxShadow: "0 4px 12px rgba(48, 48, 48, 0.3)",
                  },
                }}
                onClick={() => this.navigateToReport(urls.admin.reports.orderhistory(this.props.hotels[0].hotel_slug))}
              >
                <div>
                  <h4
                    style={{
                      color: theme.white,
                      margin: 0,
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                  >
                    Order History
                  </h4>
                  <p
                    style={{
                      color: theme.mutedWhite,
                      margin: "4px 0 0 0",
                      fontSize: "12px",
                    }}
                  >
                    Customer feedback & ratings
                  </p>
                </div>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box
                sx={{
                  backgroundColor: theme.pageBgColor,
                  padding: "18px",
                  height: "100%",
                  borderLeft: `5px solid ${theme.btnColor}`,
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "4px",
                  transition: "transform 0.2s, box-shadow 0.2s",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    cursor: "pointer",
                    boxShadow: "0 4px 12px rgba(48, 48, 48, 0.3)",
                  },
                }}
                onClick={() => this.navigateToReport(urls.admin.reports.newcustomer(this.props.hotels[0].hotel_slug))}
              >
                <div>
                  <h4
                    style={{
                      color: theme.white,
                      margin: 0,
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                  >
                    New Customers
                  </h4>
                  <p
                    style={{
                      color: theme.mutedWhite,
                      margin: "4px 0 0 0",
                      fontSize: "12px",
                    }}
                  >
                    Recently acquired customers
                  </p>
                </div>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Box
                sx={{
                  backgroundColor: theme.pageBgColor,
                  padding: "18px",
                  height: "100%",
                  borderLeft: `5px solid ${theme.btnColor}`,
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "4px",
                  transition: "transform 0.2s, box-shadow 0.2s",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    cursor: "pointer",
                    boxShadow: "0 4px 12px rgba(48, 48, 48, 0.3)",
                  },
                }}
                onClick={() => this.navigateToReport(urls.admin.reports.repeatcustomer(this.props.hotels[0].hotel_slug))}
              >
                <div>
                  <h4
                    style={{
                      color: theme.white,
                      margin: 0,
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                  >
                    Repeat Customers
                  </h4>
                  <p
                    style={{
                      color: theme.mutedWhite,
                      margin: "4px 0 0 0",
                      fontSize: "12px",
                    }}
                  >
                    Loyal & returning customers
                  </p>
                </div>
              </Box>
            </Grid>

          
          </Grid>
        {mounted && overAll && overAll.payment_method_counts && (
          <div style={{ marginBottom: "30px", paddingLeft: "12px" }}>
            <h3 style={{ marginTop: "16px",marginBottom: "16px", color: "white" }}>Payment Methods</h3>
            <Grid container spacing={2}>
              {Object.entries(overAll.payment_method_counts).map(([method, count]) => {
                // Skip methods with 0 count if you want
                if (count === 0) return null
                const methodName = method.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())
                const getMethodColor = (method) => {
                  switch (method) {
                    case "cash":
                      return "#4CAF50"
                    case "online":
                      return "#2196F3"
                    case "upi":
                      return "#FF9800"
                    case "debit_card":
                      return "#9C27B0"
                    case "credit_card":
                      return "#F44336"
                    case "net_banking":
                      return "#00BCD4"
                    case "bank_transfers":
                      return "#795548"
                    default:
                      return "#607D8B"
                  }
                }
                return (
                  <Grid item xs={6} sm={4} md={3} lg={2} key={method}>
                    <Box
                      sx={{
                        backgroundColor: "#041A29",
                        padding: "8px",
                        borderRadius: "8px",
                        textAlign: "center",
                        borderLeft: `4px solid ${getMethodColor(method)}`,
                        transition: "transform 0.2s",
                        "&:hover": {
                          transform: "translateY(-2px)",
                        },
                      }}
                    >
                      <div
                        style={{
                          fontSize: "20px",
                          fontWeight: "bold",
                          color: getMethodColor(method),
                          marginBottom: "8px",
                        }}
                      >
                        {count}
                      </div>
                      <div
                        style={{
                          fontSize: "14px",
                          color: "white",
                          textTransform: "capitalize",
                        }}
                      >
                        {methodName}
                      </div>
                    </Box>
                  </Grid>
                )
              })}
            </Grid>
  
          </div>
        )}
        <VerificationModal open={this.state.showVerificationModal} onClose={this.handleCloseVerificationModal} />
        <Toast
          open={this.state.toast.open}
          message={this.state.toast.message}
          severity={this.state.toast.severity}
          onClose={this.handleCloseToast}
        />
      </div>
    )
  }
}
export default redux(Dashboard) // Original export
// export default Dashboard // Exporting directly for demonstration